import { AUTH_ENDPOINT } from "../../consts/api-endpoints";
import { post } from "../../helpers/utils/http-client";
import { ON_PREM_AUTH_INFO_KEY } from "../../consts/common-consts";
import { getCookie, setCookie, eraseCookie } from "../../helpers/utils/cookie-utils";

export async function onPremSignIn(request) {
  try {
    const { response } = await post(`${AUTH_ENDPOINT}/signin`, request);
    // map response to compatible cognito auth user info
    response.sub = response.id;
    response.given_name = response.name;
    response.family_name = response.name;

    // Store full payload in cookie
    setCookie(ON_PREM_AUTH_INFO_KEY, JSON.stringify(response));

    return true;
  } catch (err) {
    console.debug('onPremSignIn failed cause', err);
    return false;
  }
}

export function loadAuthUserInfo() {
  try {
    const cookieData = getCookie(ON_PREM_AUTH_INFO_KEY);
    if (cookieData) {
      return JSON.parse(cookieData);
    }
  } catch (err) {

  }

  return null;
}

export function loadAccessKey() {
  const authUserInfo = loadAuthUserInfo();
  return authUserInfo?.authToken;
}

export function onPremSignOut() {
  eraseCookie(ON_PREM_AUTH_INFO_KEY);
}